export const headerData = {
  tableName: 'Activity',
  hasPaging: true,
  fields: [
    {
      fieldName: 'actionText',
      headerName: 'Action',
    },
    {
      fieldName: 'actionTable',
      headerName: 'Activity',
    },
    {
      fieldName: 'actionDate',
      headerName: 'Date',
      isDatetime: true,
    },
  ],
};
